<template>
  <div class="product-action-column-bar">
    <ym-column-button v-if="secondary"
                      class="secondary-btn"
                      :type="secondary.type"
                      :price="secondary.value"
                      :show-price="secondary.value > 0"
                      :save="secondary.save"
                      :text="secondary.hint"
                      :round="secondary.round"
                      :disabled="secondary.disabled"
                      @click="handleClickSecondary"
    />
    <ym-column-button :type="primary.type"
                      :price="primary.value"
                      :show-price="primary.value > 0"
                      :save="primary.save"
                      :text="primary.hint"
                      :round="primary.round"
                      :disabled="primary.disabled"
                      @click="handleClickPrimary"
    />
  </div>
</template>

<script>
  import YmColumnButton from '@/components/ProductDetailBottom/components/ActionColumnBtn';

  export default {
    name: 'ProductDetailBottomActionColumnBar',
    components: {
      YmColumnButton,
    },
    props: {
      primary: {
        type: Object,
        required: true,
      },
      secondary: {
        type: Object,
      },
    },
    computed: {
      routeName() {
        return this.$route.name;
      },
    },
    methods: {
      handleClickPrimary() {
        const { targetId, targetType, hint } = this.primary;
        this.$emit('click-primary', {
          targetId,
          targetType,
          hint,
          page: this.routeName,
        });
      },
      handleClickSecondary() {
        const { targetId, targetType, hint } = this.secondary;
        this.$emit('click-secondary', {
          targetId,
          targetType,
          hint,
          page: this.routeName,
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-action-column-bar {
    flex: 1;
    height: 100%;
    display: flex;
  }
</style>
